const canDrop = ({ nextPath, nextParent, navigation }) => {
  const primaryIndex = navigation.findIndex(nav => nav.isPrimary);
  const secondaryIndex = navigation.findIndex(nav => nav.isSecondary);
  const nextIndex = nextPath[0];

  if (
    (primaryIndex > -1 && nextIndex >= primaryIndex)
    || (secondaryIndex > -1 && nextIndex >= secondaryIndex)
    || nextParent?.navigationItem.isPrimary || nextParent?.navigationItem.isSecondary
    || nextParent?.navigationItem.link || nextParent?.navigationItem.page) {
    return false;
  }

  return true;
};

export default canDrop;
